module.exports = __webpack_public_path__ + "static/media/rightImg2.b0d78a33.png";